// items
export const GET_ITEMS = 'GET_ITEMS';
export const GET_CARS = 'GET_CARS';
export const GET_CAR = 'GET_CAR';
export const CREATE_CATEGORY = 'CREATE_CATEGORY';
export const GET_PUBLICITEMS = 'GET_PUBLICITEMS';
export const GET_PRIVATEITEMS = 'GET_PRIVATEITEMS';
export const GET_ITEM = 'GET_ITEM';
export const ADD_ITEM = 'ADD_ITEM';
export const DELETE_ITEM = 'DELETE_ITEM';
export const SET_CURRENT = 'SET_CURRENT';
export const CLEAR_CURRENT = 'CLEAR_CURRENT';
export const UPDATE_ITEM = 'UPDATE_ITEM';
export const UPDATESUPPLIER_ITEM = 'UPDATESUPPLIER_ITEM';
export const FILTER_ITEMS = 'FILTER_ITEMS';
export const CLEAR_ITEMS = 'CLEAR_ITEMS';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const ITEM_ERROR = 'ITEM_ERROR';

// JOB
export const GET_JOBS = 'GET_JOBS';
export const GET_JOB = 'GET_JOB';
export const ADD_JOB = 'ADD_JOB';
export const DELETE_JOB = 'DELETE_JOB';
export const UPDATE_JOB = 'UPDATE_JOB';
export const FILTER_JOBS = 'FILTER_JOBS';
export const CLEAR_JOBS = 'CLEAR_JOBS';
export const JOB_ERROR = 'JOB_ERROR';

// alert
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

// alert
export const ADD_TOCART = 'ADD_TOCART';
export const GET_CUSTOMERORDERS = 'GET_CUSTOMERORDERS';
export const CHECK_OUT = 'CHECK_OUT';
export const VERIFY_PAYMENT = 'VERIFY_PAYMENT';
export const USER_ORDER = 'USER_ORDER';
export const GET_CARTITEMS = 'GET_CARTITEMS';
export const UPDATE_CARTITEM = 'UPDATE_CARTiTEM';
export const REMOVE_FROMCART = 'REMOVE_FROMCART';

// analytics
export const GET_CUSTOMERBYLOCATION = 'GET_CUSTOMERBYLOCATION';


// authentication
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

// system users
export const GET_USERS = 'GET_USERS';
export const GET_USER = 'GET_USER';
export const ADD_USER = 'ADD_USER';
export const DELETE_USER = 'DELETE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const FILTER_USERS = 'FILTER_USERS';
export const CLEAR_USERS = 'CLEAR_USERS';
export const USER_ERROR = 'USER_ERROR';


// system drivers
export const GET_DRIVERS = 'GET_DRIVERS';
export const GET_DRIVER = 'GET_DRIVER';
export const ADD_DRIVER = 'ADD_DRIVER';
export const DELETE_DRIVER = 'DELETE_DRIVER';
export const UPDATE_DRIVER = 'UPDATE_DRIVER';
export const FILTER_DRIVERS = 'FILTER_DRIVERS';
export const CLEAR_DRIVERS = 'CLEAR_DRIVERS';
export const DRIVER_ERROR = 'DRIVER_ERROR';

// system service proveders
export const GET_SERVISEPROVIDERS = 'GET_SERVISEPROVIDERS';
export const GET_SERVISEPROVIDER = 'GET_SERVISEPROVIDER';
export const ADD_SERVISEPROVIER = 'ADD_SERVISEPROVIER';
export const DELETE_SERVISEPROVIER = 'DELETE_SERVISEPROVIER';
export const UPDATE_SERVISEPROVIER = 'UPDATE_SERVISEPROVIER';
export const FILTER_SERVISEPROVIERS = 'FILTER_SERVISEPROVIERS';
export const CLEAR_SERVISEPROVIERS = 'CLEAR_SERVISEPROVIERS';
export const SERVISEPROVIER_ERROR = 'SERVISEPROVIER_ERROR';

// system experts
export const GET_EXEPRTS = 'GET_EXEPRTS';
export const GET_PENDINGEXEPRTS = 'GET_PENDINGEXEPRTS';
export const GET_EXEPRT = 'GET_EXEPRT';
export const APPROVE_EXPERT = 'APPROVE_EXPERT';
export const REJECT_EXPERT = 'REJECT_EXPERT';
export const ADD_EXEPRT = 'ADD_EXEPRT';
export const DELETE_EXEPRT = 'DELETE_EXEPRT';
export const UPDATE_EXEPRT = 'UPDATE_EXEPRT';
export const FILTER_EXEPRTS = 'FILTER_EXEPRTS';
export const CLEAR_EXEPRTS = 'CLEAR_EXEPRTS';
export const EXEPRT_ERROR = 'EXEPRT_ERROR';

// system suppliers
export const GET_SUPPLIERS = 'GET_SUPPLIERS';
export const GET_PENDINGSUPPLIERS = 'GET_PENDINGSUPPLIERS';
export const GET_SUPPLIER = 'GET_SUPPLIER';
export const APPROVE_SUPPLIER = 'APPROVE_SUPPLIER';
export const REJECT_SUPPLIER = 'REJECT_SUPPLIER';
export const ADD_SUPPLIER = 'ADD_SUPPLIER';
export const DELETE_SUPPLIER = 'DELETE_SUPPLIER';
export const UPDATE_SUPPLIER = 'UPDATE_SUPPLIER';
export const FILTER_SUPPLIERS = 'FILTER_SUPPLIERS';
export const CLEAR_SUPPLIERS = 'CLEAR_SUPPLIERS';
export const SUPPLIER_ERROR = 'EXEPRT_ERROR';

// item cart
export const ADD_CART = 'ADD_CART';
export const UPDATE_CART = 'UPDATE_CART';
export const DELETE_CART = 'DELETE_CART';

// blog post
export const GET_POSTS = 'GET_POSTS';
export const POST_BLOG = 'POST_BLOG';
export const SET_SERACHTEXT = 'SET_SERACHTEXT';
export const GET_AUTHORPOSTS = 'GET_AUTHORPOSTS';
export const GET_POST = 'GET_POST';
export const DELETE_BLOG = 'DELETE_BLOG';
export const UPDATE_BLOG = 'UPDATE_BLOG';
export const POST_ERROR = 'POST_ERROR';
export const CLEAR_POSTS = 'CLEAR_POSTS';
export const FILTER_POSTS = 'FILTER_POSTS';
export const GET_RELATEDPOSTS = 'GET_RELATEDPOSTS';
export const GET_POSTDETAILS = 'GET_POSTDETAILS';
export const GET_RECENTPOSTS = 'GET_RECENTPOSTS';
export const GET_CATEGORIES = 'GET_CATEGORIES';
export const GET_SIMILARPOSTS = 'GET_SIMILARPOSTS';
export const GET_ADJACENTPOSTS = 'GET_ADJACENTPOSTS';
export const GET_CATEGORYPOST = 'GET_CATEGORYPOST';
export const GET_FEATUREDPOSTS = 'GET_FEATUREDPOSTS';
export const GET_COMMENTS = 'GET_COMMENTS';
export const SUBMITCOMMENT = 'SUBMITCOMMENT';

// Notifications
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const SEND_NOTIFICATION = 'SEND_NOTIFICATION';
export const SEND_NOTIFICATIONS = 'SEND_NOTIFICATIONS';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';

// Chats
export const GET_CONVERSATIONS = 'GET_CONVERSATIONS';
export const GET_CONVERSATION = 'GET_CONVERSATION';
export const GET_MESSAGES = 'GET_MESSAGES';
export const GET_MESSAGE = 'GET_MESSAGE';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const MESSAGE_ERROR = 'MESSAGE_ERROR';
export const SET_CHAT = 'SET_CHAT';
export const SET_ARRIVAL_MESSAGE = 'SET_ARRIVAL_MESSAGE';
